import React from 'react';
import styled from 'styled-components';
import {AccentColorOptions, useBreakpointDown, useBreakpointUp} from 'epic-ue-theme';
import {
    GridContainer,
    VerticalSpacer,
    Typography,
    AnimatedHeading,
    CmsButtonProps,
    Button,
    SectionInnerGridContent
} from '../../elements';
import {FeaturesCarousel} from './FeaturesCarousel';
import {FeaturesCarouselSlideProps} from './FeaturesCarousel.slide';
import {FeaturesCarouselAccordion} from './FeaturesCarousel.accordion';
import {AnimateOnViewWrap} from '../../wraps/animation';

const Styled = styled.div`
    .description .paragraph {
        color: ${(p) => p.theme.palette.text.secondary};
    }
`;

export interface FeaturesCarouselSectionProps {
    accentColor?: AccentColorOptions;
    description?: string;
    viewAllBtn?: CmsButtonProps;
    heading?: string;
    slides?: FeaturesCarouselSlideProps[];
    hidden?: boolean;
    noSlideTopSpacing?: boolean;
}

export const FeaturesCarouselSection = ({
    accentColor,
    description = '',
    viewAllBtn,
    heading = '',
    slides = [],
    hidden = false,
    noSlideTopSpacing
}: FeaturesCarouselSectionProps): JSX.Element | null => {
    const isCarousel = useBreakpointUp('md');
    const isLarge = useBreakpointUp('lg');
    const isSm = useBreakpointDown('sm');
    if (hidden) return null;

    return (
        <Styled>
            <GridContainer>
                {heading && (
                    <SectionInnerGridContent>
                        <AnimatedHeading heading={heading} />
                        <VerticalSpacer variant="custom" spacing={6} downSmSpacing={5} />
                    </SectionInnerGridContent>
                )}

                {isCarousel ? (
                    <FeaturesCarousel
                        slides={slides}
                        accentColor={accentColor}
                        isLarge={isLarge}
                        noSlideTopSpacing={noSlideTopSpacing}
                    />
                ) : (
                    <FeaturesCarouselAccordion
                        slides={slides}
                        accentColor={accentColor}
                        isSm={isSm}
                    />
                )}

                {description && (
                    <AnimateOnViewWrap translateY={30}>
                        <SectionInnerGridContent maxWidth={660}>
                            <VerticalSpacer variant="custom" spacing={7} downSmSpacing={4} />
                            <div className="description">
                                <Typography variant="p">{description}</Typography>
                            </div>
                        </SectionInnerGridContent>
                    </AnimateOnViewWrap>
                )}

                {viewAllBtn && viewAllBtn.label ? (
                    <AnimateOnViewWrap translateY={30}>
                        <VerticalSpacer variant="custom" spacing={5} downSmSpacing={4} />
                        <div style={{textAlign: 'center'}}>
                            <Button type="secondary" href={viewAllBtn.href} color={accentColor}>
                                {viewAllBtn.label}
                            </Button>
                        </div>
                    </AnimateOnViewWrap>
                ) : (
                    ''
                )}
            </GridContainer>
        </Styled>
    );
};
